import { PageMode } from '@/main/utils/pageMode';
import { Cell } from '@/main/utils/table';
import { Filter } from '@/modules/servis/jednotnaFrontaNd/store/list/state';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

export const dropdownList = {
	DphSzbOzn: [],
	OdhcenaPzn: [],
	ProvozovnaId: [],
	RabatskslevatypPzn: [],
	SkladOzn: [],
	StrednaklOzn: [],
	VydejMjId: [],
	VyrobekndOzn: [],
	ZbozidruhOzn: [],
	SplitParty: [],
	SplitBy: [],
	LineItemStatuses: [],
	StatusPendingReasons: [],
	TechiciansList:[],
	PartMRP:[] as DropdownItem[],
	ServiceJobForItems: [],
};

export const edit = {
	DphSzbOzn: null as number | null,
	ServicePackageId: null as number | null,
	EanCode: null as string | null,
	EconomyPrp: null as boolean | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	GarannavrhS2Id: null as number | null,
	KalkulacendId: null as number | null,
	Kdc: null as number | null,
	MimoKusPrp: null as boolean | null,
	Nc: null as number | null,
	NcGd: null as number | null,
	NdNr: null as string | null,
	NdNrIdx: null as number | null,
	NdNrNavrh: null as string | null,
	NdNrPseudo: null as string | null,
	ObjednId: null as number | null,
	OdhcenaPzn: null as number | null,
	OzakazkandId: null as number | null,
	Pc: null as number | null,
	PcPevna: null as number | null,
	PcPrez: null as number | null,
	PcSpec: null as number | null,
	Pnc: null as number | null,
	PneuskladndId: null as number | null,
	Poznamka2Dd: null as string | null,
	PracovnikId: null as number | null,
	PracovnikIdText: null as string | null,
	PracovnikOsobniCis: null as string | null,
	PretacPzn: null as number | null,
	ProvozovnaId: null as number | null,
	RabatSk: null as string | null,
	RabatskslevatypPzn: null as number | null,
	RabatSkText: null as string | null,
	SkladmistoId: null as number | null,
	SkladmistoIdSkladmisto: null as string | null,
	SkladmistoIdPopis: null as string | null,
	SkladMjId: null as number | null,
	SkladOzn: null as number | null,
	Sleva: null as number | null,
	SnId: null as number | null,
	Stav: null as number | null,
	StavPseudo: null as number | null,
	StrednaklOzn: null as number | null,
	Text: null as string | null,
	TextPseudo: null as string | null,
	TypSpracovavanehoZaznamu: null as number | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupProvId: null as number | null,
	VydejkandTxt: null as string | null,
	VydejMjId: null as number | null,
	VydejMjIdText: null as number | null,
	VydejMjKoef: null as number | null,
	VydejMjPoc: 1 as number | null,
	VyrobekndOzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	VyrobekndOznNavrh: null as string | null,
	VyrobekndOznPseudo: null as string | null,
	ZakazkaId: null as number | null,
	ZakazkaNr: null as number | null,
	ZakazkandextodpisId: null as number | null,
	ZaznamId: null as number | null,
	ZbozidruhOzn: null as string | null,
	FlagSlevaZvlastni: null as boolean | null,
	FlagAkceCenaNd: null as boolean | null,
	PermissionZakazkandRezInsert: null as boolean | null,
	PermissionMioInsert: null as boolean | null,
	ProvozovnaNahradaautPrp: null as boolean | null,
	Uzivatel_VyrobekndVydejPrp: null as boolean | null,
	NezavislyDalsiVydej: null as number | null,
	ContentFastCds: null as number | null,
	ProvozovnaNdPcVydejFluktSzb: null as number | null,
	PracovnikOsobniCislo: null as string | null,
	JfndZdrojEnum: null as number | null,
	UpravaS2: null as boolean | null,
	NavrhPolId: null as number | null,
	CancellationRemarks: null as string | null,
	CancellationReason: null as number | null,
	DiscountVal: null as number | null,
	IsAdditional: null as boolean | null,
	LineItemStatusId: null as number | null,
	LineItemStatusPendingReasonId: null as number | null,
	LineItemStatusPendingRemarksOthers: null as string | null,
	ActivityStartTime: null as string | null,
	ActivityEndTime: null as string | null,
	IsEligibleForCompletion: null as boolean | null,
	AdditionalJobStatus: null as boolean | null,
	UnitPrice: null as number | null,
	MrpId: null as number | null,
	Saga2: {
		OpenedFromClaimSage: null as boolean | null,
		GaranapolozS2_ZaznamId: null as number | null,
		PSNDnahradaMap: null as number | null,
	},
	Zakazka: {
		IsNabidka: null as boolean | null,
		IsSaga2: null as boolean | null,
		Stav: null as number | null,
		Druh: null as number | null,
		ZakazkaDruh: null as string | null,
		ProvozovnaId: null as number | null,
		MaKoncernoveVozidlo: null as boolean | null,
		MimoKusPrp: null as boolean | null,
		PodilMatZak: null as number | null,
		PodilSlzZak: null as number | null,
		PojistovnaId: null as number | null,
	},
	Ndsklad: {
		Pc: null as number | null,
	},
	SplitParty: [] as number[],
	SplitBy: null as number | null,
	ShareValue: null as number | null,
	CustomerShareValue: null as number | null,
	InsuranceShareValue: null as number | null,
	GoodwillShareValue: null as number | null,
	ServiceJobId: null as number | null,
	TechnicianId: null as number | null,
	IsDNPRequired: null as boolean | null,
	SagaItemStatus: null as number | null,
	PSNDnahradaMap: null as number |null
};

export const localState = {
	spc: {
		poptavaneMnozstvi: 0, // txtPocet_dotaz
		disponibilniMnozstvi: 0, // txtPocet_spc
		enabled: false, // GSI, fraGSI
		buttonEnabled: false, // cmdDoGSI
	},
	inputEnabled: { // neskor premenovat na isDisabled
		poznamka2Dd: true, // memPoznamka_2dd
		mimoKusPrp: false, // chkMimo_kus_prp
		sleva: true, // txtSleva
		pcPevna: false, // txtPC_pevna
		pc: false, // txtPc
		vyrobekndOzn: false, // btnVyrobeknd_ozn
		skladOzn: true, // cmbSklad_ozn
		ndNr: true, // txtNd_nr
		text: true, // txtText
		pracovnikId: true, // txtPracovnik_id
		strednaklOzn: true, // txtStrednakl_ozn
		nezavislyDalsiVydej: true, // txtNezavisly_DalsiVydej
		nezavislyStav: false, // txtNezavisly_Stav
		rabatSk: false, // txtRabat_sk
		vydejMjId: true, // vieVydej_mj_id
		skladmisto: false, // txtSkladmisto_id, txtSkladmisto_id_text, vieSkladmisto_id_popis
	},
	buttonEnabled: {
		cmdOK: true, // tlacitko Save
		cmdSklad: true, // tlacitko Kontrola ND
		cmdPohyb: true,
		cmdMio: true,
		cmdSo: true,
		cmdMioSklad: true,
		cmdRezervace: true,
		cmdNDNahradaPred: true,
		cmdNDNahradaPo: true,
		cmdShoda: true,
		cmdAddOld: false, // asi sa uz nebude pouzivat, slo o reset formu a pridanie dalsieho zaznamu
	},
	labels: {
		pcjedn: null as string | null,
		pccelk: null as string | null,
		pcsmlu: null as string | null,
	},
	prepocetPcDialog: {
		pc: null as number | null,
		pcNahradit: null as number | null,
		pcPrepocet: null as number | null,
		result: null as number | null,
		visible: false,
		lblPrepocetPC: null as string | null,
	},
	marketAkcePrp: false,
	nezavislyStav: null as number | null,
	vydejVratkaResult: {
		TestPcPolozkaQuestionResult: null as boolean | null,
		UseSkladovyPrevodResult: null as boolean | null,
		Akce: null as number | null,
	},
	autofocusNezavislyDalsiVydej: false,
	ndsklad: {
		Oznam: null as string | null,
		ZaznamId: null as number | null,
	},
	selectedNowNdNr: null as number | null, // TODO: rewrite - ungly temp hack after rewrite this
	selectedIdenticalNd: null as number | null,
	NdNrLoaded: false as boolean,
	IsWatchlisted: true as boolean,
	doVydejkaBeforUnload: false,
	isOceneniDone: false,
	IsOrderDisabled: false,
};

export const props = {
	mode: null as PageMode | null,
	jfnd: {
		row: null as Cell[] | null,
		options: null as Filter | null,
	},
	mnozstvi: null as number | null,
	polozkaNr: null as string | null,
	vyrobekndOzn: null as string | null,
	saga2Status: null as number | null,
	pseudonahradaMap: null as number | null,
	polozkaId: null as number | null,
	filter: {
		ZakazkaId: null as number | null,
		PracovnikId: null as number | null,
		WarehouseId: null as number | null,
		ZakazkaDruh: null as string | null,

	},
};
